import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx, translateTemplateLevelText } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { AchievementLevelProgress } from '../../helpers/achievement';
import { CommonIcon } from '../common/CommonIcon';
import { BorderLinearProgress } from './BorderLinearProgress';

type ExternalAchievementConditionDisplayProps = {
  achievement: AchievementLevelProgress;
};

export const ExternalAchievementConditionDisplay: FC<ExternalAchievementConditionDisplayProps> = ({ achievement }) => {
  const { t } = useTranslation();
  const nextLevel = achievement.achievementLevels?.[achievement.currentLevel];
  const target = achievement.currentTarget;
  const percentage = Math.min(Math.round((achievement.currentValue / target) * 100), 100);
  const nextLevelDescription = nextLevel
    ? translateTemplateLevelText(t, achievement.templateId, achievement.currentLevel, 'description', nextLevel.description)
    : null;

  return (
    <Box sx={{ width: '100%', borderRadius: '16px', overflow: 'hidden', ...liquidGlassRowShadowSx }}>
      <Box sx={{ borderRadius: 'inherit', px: '14px', py: '12px', ...liquidGlassSurfaceFillSx }}>
        <Stack direction="row" gap="12px" alignItems="center">
          <CommonIcon icon="open_in_new" type="filled" size={30} color="var(--tg-theme-button-color)" />
          <Stack direction="column" gap={0.5} sx={{ flex: 1, minWidth: 0 }}>
            <Text weight="2" style={{ color: 'var(--tg-theme-text-color)' }}>{t('achievementEditor.external')}</Text>
            <Text style={{ fontSize: '12px', color: 'var(--tg-theme-hint-color)' }}>
              {nextLevelDescription ?? t('achievementEditor.allLevelsCompleted')}
            </Text>
          </Stack>
          <Stack direction="column" gap={0.5} alignItems="flex-end" sx={{ flexShrink: 0 }}>
            <Text style={{ fontSize: '12px', color: 'var(--tg-theme-hint-color)' }}>{achievement.currentValue}/{target}</Text>
            <BorderLinearProgress variant="determinate" value={percentage} sx={{ height: '10px', width: '80px' }} />
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
